"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = void 0;
function isEmpty(obj) {
    return obj && Object.keys(obj).length === 0;
}
exports.isEmpty = isEmpty;
//# sourceMappingURL=object.js.map